<template>
  <div class="register-container">
    <div class="left">
      <div class="content">
        <div class="video-container">
          <video class="video" loop muted playsinline controls>
            <source
              :src="require('../../assets/onboarding_video.mp4')"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      <div class="row content-images">
        <div class="col-md-6">
          <img
            src="../../assets/img/reg-bg-left.jpg"
            alt="registration image"
          />
        </div>
        <div class="col-md-6">
          <img
            src="../../assets/img/reg-bg-right.jpg"
            alt="registration image"
          />
        </div>
      </div>
    </div>

    <div class="right">
      <p class="alt-text">
        Have an account?
        <router-link class="signup-link special" to="/auth/login"
          >Sign In</router-link
        >
      </p>
      <div class="content">
        <div class="info">
          <h2>Interested in Installmental Solar Payment?</h2>
          <p>
            Complete the form to commence your KYC and credit check process
            online. Please ensure your name matches the one on your BVN to
            ensure seamless verification.
          </p>
        </div>
        <RegisterForm />
      </div>
      <div class="row content-images-below">
        <div class="col-md-6">
          <img
            src="../../assets/img/reg-bg-left.jpg"
            alt="registration image"
          />
        </div>
        <div class="col-md-6">
          <img
            src="../../assets/img/reg-bg-right.jpg"
            alt="registration image"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import axios from "axios";
import { mapActions } from "vuex";
import ArnergyLoader from "./kitchen/ArnergyLoader";
import ArnergyFormInput from "./kitchen/ArnergyFormInput";
import RegisterForm from "../forms/register-form";

export default {
  name: "register",
  components: {
    ArnergyLoader,
    ArnergyFormInput,
    RegisterForm
  },
  data() {
    return {
      bgColor: "../../assets/img/bg-image.jpg"
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    ...mapActions(["setUserSession", "setAccess"])
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_reduced_variables.scss";

img.logo-cover {
  position: absolute;
  top: 3.75rem;
  left: 3.75rem;
  z-index: 1;

  @media (max-width: 480px) {
    position: relative;
    top: inherit;
    left: inherit;
    margin: auto;
  }
}

.logo {
  width: 125px;
}

.register-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 115vh;
  max-width: 100% !important;
  background: linear-gradient(to bottom, #e3e8ec 70%, #3493f1e5 30%);
  padding: 32px 48px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    height: auto;
  }
}

.content {
  margin: auto;
}

.left {
  .content {
    max-width: 100%;
    height: auto;

    @media (max-width: 480px) {
      max-width: 100%;
    }
  }
}
.content-images {
  img {
    border: 4px solid white;
    border-radius: 12px;
    height: 40vh;
    width: 100%;
    margin-top: 8px;
    @media (max-width: 480px) {
      display: none;
    }
  }
}

.content-images-below {
  img {
    display: none;
    @media (max-width: 480px) {
      display: block;
      border: 4px solid white;
      border-radius: 12px;
      width: 100%;
      height: 25vh;
      margin-top: 8px;
    }
  }
}

.special {
  color: #e18712;
}

.right {
  .info {
    // text-align: right;
    color: black;
    width: 90%;
    @media (max-width: 480px) {
      text-align: justify;
      width: 100%;
    }
    h2 {
      font-size: 3.2rem;
      font-weight: 700;
      text-align: center;
      width: 88%;
      margin-right: auto;
      margin-left: 12%;
      @media (max-width: 480px) {
        text-align: center;
        width: 100%;
        margin-right: auto;
        margin-left: auto;
      }
    }
    p {
      font-size: 1.8rem;
      width: 88%;
      margin-right: auto;
      margin-left: 12%;
      color: #666666;
      font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
        "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
      @media (max-width: 480px) {
        width: 100%;
        margin-right: auto;
        margin-left: auto;
      }
    }
  }

  .line {
    width: 100%;
    height: 5px;
    background-color: #e18712;
    margin: 10px auto;
  }
}

.alt-text {
  text-align: right;
  color: black;

  // @media (max-width: 480px) {
  //   position: relative;
  //   top: inherit;
  //   right: inherit;
  //   text-align: center;
  // }
}

.video-container {
  display: grid;
  grid-gap: 5px;

  p {
    background: #0892d0;
    padding: 12px 24px;
    color: white;
    text-align: center;
    margin: auto;
    border-radius: 12px;
  }
}

.video {
  border: 5px solid white;
  border-radius: 12px;
  // height: 60vh;
  width: 100%;
}

.socials {
  background-color: #0d3b4a;
  color: white;
  padding: 8px;
  margin: auto;
  margin-top: 30px;

  h6 {
    color: white;
    text-align: center;
    font-style: italic;
  }

  img {
    width: 25px;
  }

  ul {
    display: flex;
    gap: 10px;

    @media (max-width: 480px) {
      display: grid;
      grid-template-columns: 1fr;
    }
  }

  li {
    list-style: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Register.vue